import { useState } from 'react';
import { ApiDocsTab } from '../components/integration/ApiDocsTab';
import { ApiKeysTab } from '../components/integration/ApiKeysTab';
import { ApiLogTab } from '../components/integration/ApiLogTab';
import { filterActive, filterIdle, pageContainer, pageHeader, pageSubtitle, pageTitle } from '../lib/styles';

type Tab = 'keys' | 'docs' | 'log';

/**
 * /admin/api — «Публичный API приёма заявок»: управление ключами, документация
 * для интеграторов (задача 9), журнал запросов/доставки вебхуков (задача 10).
 */
export function AdminApiPage() {
  const [tab, setTab] = useState<Tab>('keys');

  return (
    <div className={pageContainer}>
      <div className={pageHeader}>
        <div>
          <h1 className={pageTitle}>API</h1>
          <p className={pageSubtitle}>Приём заявок от внешних сервисов: ключи, документация, журнал.</p>
        </div>
      </div>

      <div className="mb-4 flex flex-wrap gap-2">
        <button onClick={() => setTab('keys')} className={tab === 'keys' ? filterActive : filterIdle}>
          Ключи
        </button>
        <button onClick={() => setTab('docs')} className={tab === 'docs' ? filterActive : filterIdle}>
          Документация
        </button>
        <button onClick={() => setTab('log')} className={tab === 'log' ? filterActive : filterIdle}>
          Журнал
        </button>
      </div>

      {tab === 'keys' && <ApiKeysTab />}
      {tab === 'docs' && <ApiDocsTab />}
      {tab === 'log' && <ApiLogTab />}
    </div>
  );
}
